<template>
    <div class="mvt-map-static">
        <div v-if="defaultCenterMarker" class="default-center-marker"><i :class="icon"></i></div>
        <img ref="img" :src="placeholderUrl" :loading="eager ? 'eager' : 'lazy'" :fetchpriority="eager ? 'high' : 'auto'" :alt="alt" v-once >
        <slot></slot>
    </div>
</template>
<script src="./mvt-mapstatic.js"></script>
<style lang="scss">
@use "./mvt-mapstatic.scss" as *;
</style>
